export const DropdownActionTypes = {
  blur: 'dropdown:blur',
  escapeKeyDown: 'dropdown:escapeKeyDown',
  toggle: 'dropdown:toggle',
  open: 'dropdown:open',
  close: 'dropdown:close'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useDropdown/useDropdown.types.js
// module id = 435
// module chunks = 31